<div class="maia-geocode-step" data-testid="maia-geocode-panel">
    <div class="step-canvas">
        <div class="step-stage">

            <section class="wizard-card" data-testid="maia-geocode-card">


                <ng-container [ngSwitch]="status">

                    <!-- ============================ In progress ============================ -->
                    <ng-container *ngSwitchCase="GeocodeStatus.IN_PROGRESS">
                        <h2 class="card-title">Geocoding locations</h2>

                        <div class="progress-card" data-testid="maia-geocode-progress">
                            <div class="progress-card-head">
                                <span class="progress-dot" aria-hidden="true"></span>
                                <span class="progress-title">Geocoding in progress…</span>
                            </div>
                            <p class="progress-file">Processing locations from <strong>{{ fileName }}</strong></p>

                            <div class="parse-progress">
                                <div class="parse-progress-track">
                                    <div class="parse-progress-fill" [style.width.%]="progressPercent"></div>
                                </div>
                                <span class="parse-progress-value">{{ progressPercent }}%</span>
                            </div>

                            <!-- Spinner only: the client found the status text low value, but the
                                 spinner is the one sign of activity while the bar waits on a batch. -->
                            <p class="progress-message">
                                <svg class="progress-message-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2.4"
                                            stroke-linecap="round" stroke-dasharray="34 22"/>
                                </svg>
                            </p>
                        </div>
                    </ng-container>

                    <!-- ============================== Complete ============================== -->
                    <ng-container *ngSwitchCase="GeocodeStatus.COMPLETE">

                        <ng-container *ngIf="allResolved; else needsAttention">
                            <h2 class="card-title">Geocoding complete</h2>

                            <div class="success-banner" data-testid="maia-geocode-success-banner">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <circle cx="12" cy="12" r="9" fill="currentColor"/>
                                    <path d="m8.5 12.2 2.3 2.3 4.7-4.7" stroke="#ffffff" stroke-width="1.8"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>{{ summary?.geocoded }}/{{ summary?.totalLocations }} locations geocoded successfully</span>
                            </div>

                            <div class="card-actions">
                                <!-- <button type="button"
                                        class="secondary-button"
                                        data-testid="maia-geocode-download-button"
                                        (click)="downloadRequested.emit()">
                                    Download
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path d="M12 3v12m0 0-4.5-4.5M12 15l4.5-4.5M5 20h14"
                                              stroke="currentColor" stroke-width="1.8"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button> -->
                                <button type="button"
                                        class="primary-button"
                                        data-testid="maia-geocode-continue-button"
                                        (click)="continueRequested.emit()">
                                    Continue to Enrichment
                                </button>
                            </div>
                        </ng-container>

                        <!-- ====================== Needs attention (still COMPLETE) ====================== -->
                        <ng-template #needsAttention>
                            <h2 class="card-title">Geocoding complete</h2>
                            <!-- Two descriptions, because the screen has two shapes: the
                                 editing instructions are wrong once the table is gone. -->
                            <p *ngIf="!exceedsEditableLimit" class="card-description">
                                {{ summary?.failedCount }} locations couldn't be geocoded and will be marked in
                                the exported file for review. Paste the full address in the Address box for
                                automatic verification, or enter coordinates from Google Maps in the Coordinates
                                box for latitude and longitude. Use <strong>Find on map ↗</strong> to research the
                                location in Google Maps. Paste the full address or a coordinate pair, and it will
                                be split automatically.
                            </p>
                            <p *ngIf="exceedsEditableLimit" class="card-description">
                                {{ summary?.failedCount }} locations couldn't be geocoded and will be marked in
                                the exported file for review. Download the file, correct the addresses or add
                                coordinates in it, and upload it back — or continue and leave them as they are.
                            </p>

                            <div class="stats-bar" data-testid="maia-geocode-stats">
                                <span><strong>Preserved:</strong> {{ summary?.preserved }}</span>
                                <span><strong>Geocoded:</strong> {{ summary?.geocoded }}</span>
                                <span class="stats-failed"><strong>Failed:</strong> {{ summary?.failedCount }}</span>
                            </div>

                            <div class="attention-banner" data-testid="maia-geocode-attention-banner">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 9v4.5M12 16.5v.01M10.29 3.86 1.82 18a1.5 1.5 0 0 0 1.29 2.25h17.78A1.5 1.5 0 0 0 22.18 18L13.71 3.86a1.5 1.5 0 0 0-2.42 0z"
                                          stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                                </svg>
                                <span>{{ summary?.failedCount }} locations need attention</span>
                            </div>

                            <div *ngIf="isLoadingAttention" class="attention-loading" data-testid="maia-geocode-attention-loading">
                                Loading the locations that need attention…
                            </div>

                            <p *ngIf="attentionError" class="attention-error" data-testid="maia-geocode-attention-error">
                                {{ attentionError }}
                            </p>

                            <!-- Columns are built from the API's rawData keys, so the
                                 grid template has to be generated rather than fixed. -->
                            <div *ngIf="!isLoadingAttention && visibleAttentionRows.length"
                                 class="attention-table"
                                 data-testid="maia-geocode-attention-table">
                                <div class="attention-scroll">
                                    <div class="attention-grid" [style.grid-template-columns]="gridTemplate">

                                        <span class="attention-head" *ngFor="let column of attentionColumns">
                                            {{ column.label }}
                                        </span>
                                        <span class="attention-head attention-head-action">Action</span>

                                        <ng-container *ngFor="let row of visibleAttentionRows">
                                            <!-- No row-level testid: it used to sit on the "#" cell, and
                                                 repeating it on every column would duplicate the id across
                                                 the row. Each input and the action button already carry
                                                 row.id, so the row is still addressable. -->
                                            <span class="attention-cell" *ngFor="let column of attentionColumns">
                                                <input type="text"
                                                       class="attention-input"
                                                       [class.attention-input-error]="column.key === 'latLng' && row.error"
                                                       [placeholder]="column.key === 'latLng' ? 'lat, lng' : column.label"
                                                       [title]="column.key === 'latLng' && row.coordinateHint ? row.coordinateHint : null"
                                                       [disabled]="row.isSaving"
                                                       [(ngModel)]="row.values[column.key]"
                                                       (ngModelChange)="column.key === 'latLng' ? onCoordinateInput(row) : null"
                                                       [attr.data-testid]="'maia-geocode-input-' + row.id + '-' + column.key"/>

                                                <span *ngIf="column.key === 'latLng' && row.error"
                                                      class="attention-cell-error"
                                                      [attr.data-testid]="'maia-geocode-row-error-' + row.id">{{ row.error }}</span>
                                            </span>

                                            <span class="attention-cell attention-cell-action">
                                                <button type="button"
                                                        class="secondary-button attention-update-button"
                                                        [disabled]="!isRowEdited(row) || row.isSaving || isSavingRows"
                                                        [attr.data-testid]="'maia-geocode-update-' + row.id"
                                                        (click)="updateRow(row)">
                                                    {{ row.isSaving ? 'Retrying…' : 'Retry' }}
                                                </button>
                                                <button type="button"
                                                        class="secondary-button attention-map-button"
                                                        [attr.data-testid]="'maia-geocode-find-on-map-' + row.id"
                                                        (click)="findOnMapRow(row)">
                                                    <!-- Pin comes from CSS (.attention-map-button::before) so the
                                                         multi-colour SVG isn't repeated, with duplicate ids, per row. -->
                                                    Find on map ↗
                                                </button>
                                            </span>
                                        </ng-container>

                                    </div>
                                </div>
                            </div>

                            <!-- Past the limit the table is not rendered at all: the
                                 download/upload round trip below is the only route. -->
                            <p *ngIf="exceedsEditableLimit"
                               class="attention-overflow-note"
                               data-testid="maia-geocode-attention-overflow">
                                {{ attentionRows.length }} locations need fixing — too many to edit here.
                                Use <strong>Download to Review or Edit</strong>, correct them in the file,
                                then <strong>Upload corrected file</strong>.
                            </p>

                            <div class="card-actions card-actions-split">
                                <!-- Round trip for the rows that don't fit the table:
                                     download, fix in bulk, bring the file back. -->
                                <div class="bulk-fix-actions">
                                    <button type="button"
                                            class="link-button"
                                            data-testid="maia-geocode-download-review-button"
                                            [disabled]="!canDownloadForReview || isDownloading"
                                            [title]="canDownloadForReview ? null : 'Available when there are more than ' + maxEditableRows + ' locations to fix'"
                                            (click)="downloadNotFound()">
                                        {{ isDownloading ? 'Preparing download…' : 'Download to Review or Edit' }}
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path d="M12 3v12m0 0-4.5-4.5M12 15l4.5-4.5M5 20h14"
                                                  stroke="currentColor" stroke-width="1.8"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>

                                    <input #correctedFileInput
                                           type="file"
                                           class="corrected-file-input"
                                           data-testid="maia-geocode-corrected-file-input"
                                           [attr.accept]="acceptedExtensions"
                                           (change)="onCorrectedFileChange($event)"/>

                                    <button type="button"
                                            class="link-button"
                                            data-testid="maia-geocode-upload-corrected-button"
                                            [disabled]="!canDownloadForReview || isImporting"
                                            [title]="canDownloadForReview ? null : 'Available once you have a file to bring back'"
                                            (click)="openCorrectedFilePicker()">
                                        {{ isImporting ? 'Importing…' : 'Upload corrected file' }}
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path d="M12 20V8m0 0-4.5 4.5M12 8l4.5 4.5M5 4h14"
                                                  stroke="currentColor" stroke-width="1.8"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>

                                    <span *ngIf="correctedFileName"
                                          class="corrected-file-name"
                                          data-testid="maia-geocode-corrected-file-name">{{ correctedFileName }}</span>

                                    <span *ngIf="downloadError"
                                          class="corrected-file-error"
                                          data-testid="maia-geocode-download-error">{{ downloadError }}</span>

                                    <span *ngIf="importMessage"
                                          class="corrected-file-success"
                                          data-testid="maia-geocode-import-success">{{ importMessage }}</span>

                                    <span *ngIf="importError"
                                          class="corrected-file-error"
                                          data-testid="maia-geocode-import-error">{{ importError }}</span>

                                    <span *ngIf="updateError"
                                          class="corrected-file-error"
                                          data-testid="maia-geocode-update-error">{{ updateError }}</span>
                                </div>
                                <div class="card-actions-right">
                                    <!-- Hidden, not just disabled, past the editable limit:
                                         with no table there is nothing it could retry. -->
                                    <button type="button"
                                            *ngIf="!exceedsEditableLimit"
                                            class="secondary-button"
                                            data-testid="maia-geocode-update-all-button"
                                            [disabled]="!hasEditedLocation || isSavingRows"
                                            (click)="updateAllEdited()">
                                        {{ isSavingRows ? 'Retrying…' : 'Retry All' }}
                                    </button>
                                    <button type="button"
                                            class="primary-button"
                                            data-testid="maia-geocode-continue-without-fixing-button"
                                            (click)="continueWithoutFixing()">
                                        {{ hasEditedLocation ? 'Retry and Continue' : 'Continue without fixing' }}
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>

                    <!-- ================================ Failed ================================ -->
                    <ng-container *ngSwitchCase="GeocodeStatus.FAILED">
                        <h2 class="card-title">Geocoding failed</h2>
                        <p class="card-description">{{ errorMessage }}</p>

                        <div class="card-actions">
                            <button type="button"
                                    class="primary-button"
                                    data-testid="maia-geocode-retry-job-button"
                                    (click)="retryJob()">
                                Try again
                            </button>
                        </div>
                    </ng-container>

                </ng-container>

            </section>

        </div>
    </div>
</div>
